<template>
  <div>
    <module-title :module-title="moduleTitle"/>
    <div class="ljb-item-base-padding">
      <div
        class="field flex">
        <div
          v-for="(item,key) in getIcons"
          :key="key"
          class="item"
          @click="go(item,key)">
          <p class="text">{{ item.text }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModuleTitle from '../title/ModuleTitle'

export default {
  name: 'CommonProblems',
  components: {ModuleTitle},
  data () {
    return {
      moduleTitle: {
        title: '常见问题咨询',
        text: ''
      },
      getIcons: [
        {text: '离婚纠纷', id: '2'},
        {text: '财产分割', id: '2'},
        {text: '借款纠纷', id: '4'},
        {text: '消费维权', id: '6'},
        {text: '伤残鉴定', id: '1'},
        {text: '劳动维权', id: '5'},
        {text: '房产纠纷', id: '3'},
        {text: '金融诈骗', id: '4'}
      ]
    }
  },
  methods: {
    go (item) {
      console.log('go', item)
      this.$router.push({name: 'SubTel', params: {id: item.id}})
    }
  }

}
</script>

<style scoped lang="scss">
  .field {
    justify-content: space-between;
  }

  .item {
    text-align: center;
    width: 78px;
    height: 21px;
    border-radius: 20px;
    border: $base-color 1px solid;
    margin-bottom: 9px;
    @extend .double-center;
  }
  .text{
    font-size: $text-font-size;
    color: $base-color;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/CommonProblems.vue